import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import http from '../config/http-service';
import { ICrmSupplierContactQuotaData } from './use-get-crm-supplier-contact-quotas-api';

const endpoint = 'ums/v1/crm/management/suppliers/contact-quotas';

type TData = ICrmSupplierContactQuotaData;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, number];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'> & {
  enabled?: boolean;
};
type ReturnType = UseQueryResult<TData, TError>;

export function useGetCrmSupplierContactQuotaByIdApi(id: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const { enabled: userEnabled = true, ...restOptions } = options || {};

  const queryKey: TQueryKey = [endpoint, id];

  const queryFn = async (): Promise<TData> => {
    const { data } = await http.get(`${endpoint}/${id}`);
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn && userEnabled && !!id,
    ...restOptions,
  });
}
